import EarlyAccess from "../components/EarlyAccess";
import Hero from "../components/Hero";
import HowWorks from "../components/HowWorks";
import Layout from "../components/Skeleton/Layout";

const Fylo = () => {
  return (
    <Layout>
      <Hero />
      <HowWorks />
      <EarlyAccess />
    </Layout>
  );
};

export default Fylo;
